// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2XUN8","errorLogs":"styles_errorLogs__2K0uL"};